import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { formatDateEsShort, lightenColor } from '../../../utils/work-schedule-bulk.util';

export interface DialogRepeatPatternDayPreview {
  letter: string;
  color: string;
}

export interface DialogRepeatPatternData {
  patternName: string;
  patternColor: string;
  days: DialogRepeatPatternDayPreview[];
  /** Lunes de la semana visible en el calendario — desde ahí se cuentan las semanas a repetir. */
  weekStartDate: Date;
  /** Rango de fecha ya formateado de esa misma semana (ej. "01 – 07 sep 2026"), para no inventar
   * un "número de semana" que la app no maneja en ningún otro lado. */
  weekRangeLabel: string;
}

const MIN_WEEKS = 1;
const MAX_WEEKS = 52;

@Component({
  selector: 'app-dialog-repeat-pattern',
  templateUrl: './dialog-repeat-pattern.component.html',
  styleUrls: ['./dialog-repeat-pattern.component.scss']
})
export class DialogRepeatPatternComponent {
  readonly minWeeks = MIN_WEEKS;
  readonly maxWeeks = MAX_WEEKS;
  weeks = 4;

  constructor(
    public dialogRef: MatDialogRef<DialogRepeatPatternComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogRepeatPatternData
  ) {}

  /** Fondo pastel + texto en el color real del turno — misma idea que las celdas del calendario
   * masivo (lightenColor al 86%), para que la "cajita" de días se vea suave y no como chips
   * saturados sueltos. */
  chipBackground(color: string): string {
    return lightenColor(color, 0.82);
  }

  get endDateLabel(): string {
    const endDate = new Date(this.data.weekStartDate);
    endDate.setDate(endDate.getDate() + (this.weeks * 7) - 1);
    return formatDateEsShort(endDate);
  }

  setWeeks(value: number): void {
    this.weeks = value;
    this.clampWeeks();
  }

  increment(): void {
    this.setWeeks(this.weeks + 1);
  }

  decrement(): void {
    this.setWeeks(this.weeks - 1);
  }

  clampWeeks(): void {
    if (!this.weeks || isNaN(this.weeks)) { this.weeks = MIN_WEEKS; return; }
    this.weeks = Math.min(MAX_WEEKS, Math.max(MIN_WEEKS, Math.round(this.weeks)));
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  apply(): void {
    this.clampWeeks();
    this.dialogRef.close(this.weeks);
  }
}
